"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lockout = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var mapStateToProps = function (state) { return state.lockout; };
var mapDispatchToProps = function () { return ({}); };
exports.lockout = function (props) {
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { id: "lockout-page", className: "l-container l-container--rslim l-pad-around" },
            React.createElement("div", { className: "l-container__main" },
                React.createElement("div", { className: "c-jumbo c-jumbo--lift" },
                    React.createElement("div", { className: "c-jumbo__header" },
                        React.createElement("div", { className: "c-jumbo__header-main" },
                            React.createElement("div", { className: "c-jumbo__title" }, props.nameLockoutTitle),
                            React.createElement("div", { className: "c-jumbo__caption" }, props.nameLockoutCaption))),
                    React.createElement("div", { className: "c-jumbo__body" },
                        React.createElement("div", { className: "c-jumbo__actions" },
                            React.createElement("a", { href: "/", className: "o-btn o-btn--primary" }, props.nameBacktoHomePage))))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.lockout);
